import {
  SET_LABELS,
  SET_LIBRARIES,
  TOGGLE_LOADING_LABELS,
  TOGGLE_LOADING_LIBRARIES,
  UPDATE_INSTAGRAM_CONNECTION_STATUS,
} from './socialListeningTypes';

const initialState = {
  isLoading: false,
  campaigns: [],
  instagramConnected: false,
  labels: [],
  isLoadingLabels: false,
  libraries: {},
  isLoadingLibraries: false,
  totalLibraryPages: {},
};

const socialListeningReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_INSTAGRAM_CONNECTION_STATUS:
      return {
        ...state,
        instagramConnected: action.payload,
      };
    case TOGGLE_LOADING_LABELS:
      return {
        ...state,
        isLoadingLabels: action.payload,
      };
    case SET_LABELS:
      return {
        ...state,
        labels: action.payload,
      };
    case TOGGLE_LOADING_LIBRARIES:
      return {
        ...state,
        isLoadingLibraries: action.payload,
      };
    case SET_LIBRARIES: {
      if (action.payload.evict) {
        return {
          ...state,
          totalLibraryPages: { [action.payload.key]: action.payload.totalPages },
          libraries: { [action.payload.key]: action.payload.data },
          isLoadingLibraries: false,
        };
      }
      return {
        ...state,
        totalLibraryPages: { ...state.totalLibraryPages, [action.payload.key]: action.payload.totalPages },
        libraries: { ...state.libraries, [action.payload.key]: action.payload.data },
        isLoadingLibraries: false,
      };
    }
    default:
      return { ...state };
  }
};

export default socialListeningReducer;
